// Minimal deep merge for composing GraphQL filter objects.
// Arrays are replaced, objects are recursively merged.
export function deepMerge<T extends Record<string, unknown>>(
  target: T,
  ...sources: Array<Partial<T> | undefined>
): T {
  for (const source of sources) {
    if (!source) continue;
    for (const [key, value] of Object.entries(source)) {
      const targetValue = target[key];
      if (Array.isArray(value)) {
        // Type assertion needed for dynamic property assignment
        (target as Record<string, unknown>)[key] = value;
      } else if (
        value &&
        typeof value === "object" &&
        !Array.isArray(value) &&
        targetValue &&
        typeof targetValue === "object" &&
        !Array.isArray(targetValue)
      ) {
        // Recursively merge nested objects
        (target as Record<string, unknown>)[key] = deepMerge(
          { ...(targetValue as Record<string, unknown>) },
          value as Record<string, unknown>
        );
      } else if (value !== undefined) {
        (target as Record<string, unknown>)[key] = value;
      }
    }
  }
  return target;
}
